// Builds the correct login redirect URL for the rebranded webinar detail
// page. The `authRebrand` flag comes from the Inertia server prop
// (`auth_rebrand`) so the shape is consistent with what the server would
// generate itself via ApplicationController#require_login — the client
// never reads the FeatureToggle directly.
//
//   authRebrand ON  → /login?redirect_after_login=/webinars/:slug
//   authRebrand OFF → /?login_popup_auto_shown=1&redirect_after_login=/webinars/:slug
//
// After login, Authentications::SessionsController#url_after_create honors
// `redirect_after_login` and sends the user back to the webinar page.
export function buildLoginUrl(slug, authRebrand) {
  const target = `/webinars/${slug}`;
  const encoded = encodeURIComponent(target);
  if (authRebrand) {
    return `/login?redirect_after_login=${encoded}`;
  }
  return `/?login_popup_auto_shown=1&redirect_after_login=${encoded}`;
}
